import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useTranslation } from 'react-i18next';
import Seo from '@/components/Seo';

const PrivacyPolicy = () => {
  const { t } = useTranslation('privacy-policy');
  const sections = t('sections', { returnObjects: true }) as Array<{
    heading: string;
    paragraphs: string[];
    bullets?: string[];
    lastUpdatedLocale?: string;
  }>;

  return (
    <>
      <Seo page="privacy-policy" />
      <Navbar />
      <main className="pt-24 pb-12 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8">
            <h1 className="text-3xl font-bold text-dental-dark mb-8">{t('title')}</h1>

            {sections.map((section) => {
              const locale = section.lastUpdatedLocale;
              const isLastUpdatedBlock =
                section.paragraphs?.length &&
                locale &&
                section.paragraphs[section.paragraphs.length - 1].endsWith(':');

              return (
                <section key={section.heading} className="mb-8">
                  <h2 className="text-xl font-semibold text-dental-dark mb-4">{section.heading}</h2>

                  {section.paragraphs?.map((p, idx) => {
                    const isLastLine = idx === section.paragraphs.length - 1;
                    if (isLastUpdatedBlock && isLastLine) {
                      return (
                        <p key={`${section.heading}-p-${idx}`} className="text-gray-600">
                          {p} {new Date().toLocaleDateString(locale)}
                        </p>
                      );
                    }
                    return (
                      <p key={`${section.heading}-p-${idx}`} className="text-gray-600 mb-4">
                        {p}
                      </p>
                    );
                  })}

                  {section.bullets && (
                    <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
                      {section.bullets.map((item) => (
                        <li key={`${section.heading}-${item}`}>{item}</li>
                      ))}
                    </ul>
                  )}
                </section>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy; 